import { render, staticRenderFns } from "./PostsSidebar.vue?vue&type=template&id=2ea2eb8f&"
import script from "./PostsSidebar.vue?vue&type=script&lang=js&"
export * from "./PostsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports